import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ProjectTypeReducer } from './reducer';
import { ProjectTypeEffects } from './effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('projectType', ProjectTypeReducer),
    EffectsModule.forFeature([ProjectTypeEffects])
  ]
})
export class ProjectTypeStoreModule { }
